import { render, staticRenderFns } from "./SalesChannelPayments.vue?vue&type=template&id=4ed815a5&scoped=true&"
import script from "./SalesChannelPayments.vue?vue&type=script&lang=js&"
export * from "./SalesChannelPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed815a5",
  null
  
)

export default component.exports